import {h, Component} from 'preact';
import { connect } from 'react-redux';
import reduce from '../reducers';
import util from '../util';
import constants from '../constants';
import DeleteOutlined from '@ant-design/icons/lib/icons/DeleteOutlined';
import MenuContentEditItem from './MenuContentEditItem';
import { markAsModified } from '../canvas/mark-as-modified';
import * as actions from '../actions';
import store from '../store';
import MenuObject from '../canvas/menu-object';
import {getSizeAndPrice} from '../canvas/menu-object-renderer';
import AsideMenuObjectText from "./AsideMenuObjectText";
import DragSortableList from '../lib/DragSortableList';

export default @connect(reduce, actions)
class MenuContentItems extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active: null,
      activeIdx: '',
      activeIcons: null,
      iconUploads: [],
      isEditMode: !this.props.isMobileVersion,
      items: this.props.items
    };
  }

  shouldComponentUpdate(props, state) {
    return props.items.length !== this.props.items.length ||
      props.activeIdx !== this.props.activeIdx ||
      props.$element !== this.props.$element ||
      state.isEditMode !== this.state.isEditMode ||
      state.activeIdx !== this.state.activeIdx;
  }

  editItem(ev, idx) {
    this.props.onEditItemClick(idx);
    store.dispatch(actions.setIsMenuObjectCopied(false));
    store.dispatch(actions.goToSubview('edit'));

    this.setState({
      activeIdx: idx,
      active: this.props.items[idx],
      isEditMode: true
    });
  }

  closeEditItem() {
    if (JSON.stringify(this.state.active) === JSON.stringify(new MenuObject.MenuItem()) && this.state.items.length === 1) {
      store.dispatch(actions.setMenuObjectItems([]));
      MenuObject.updateContent(this.props.$element, []);
    }
    this.setState({
      activeIdx: '',
      active: null,
      isEditMode: false
    });
    this.props.onCloseEditMode();
    store.dispatch(actions.goToSubview('items'));
  }

  getActiveIcons(icons) {
    return icons.map((icon) => (
      <span> {icon && icon.type === 'svg' &&
      <svg className={'iconElement'}>
        <use xlinkHref={constants.appPrefix + '/svg/icon-library/menu-icons.svg/#' + icon.iconKey}/>
      </svg>}
        {icon && icon.type !== 'svg' &&
        <img className={"iconElement"} width="28px" height="28px"
             src={icon.iconKey.includes("icon-uploads") ? util.getUploadedIconPath(icon) : constants.SECURE_S3_OO_PATH + icon.iconKey}/>}
      </span>));
  }

  dragHandleIcon() {
    return <svg className={`drag-icon`} xmlns="http://www.w3.org/2000/svg" x="0" y="0"
                enableBackground="new 0 0 384 384" version="1.1" viewBox="0 0 384 384" xmlSpace="preserve">
      <circle cx="192" cy="42.667" r="42.667"></circle>
      <circle cx="192" cy="192" r="42.667"></circle>
      <circle cx="192" cy="341.333" r="42.667"></circle>
    </svg>
  }

  save() {
    markAsModified();
    MenuObject.updateContent(this.props.$element, this.state.items);
    if (store.getState().isMobileVersion) this.props.goToItems();
  }

  saveItem(updated) {
    markAsModified();
    this.setState(old => {
      let items = [...old.items];
      items.splice(old.activeIdx, 1, updated);
      return {
        items,
      }
    });
    MenuObject.updateContent(MenuObject.getActive(), this.state.items);
  }

  updateList() {
    this.setState({items: this.props.menuObjectItems});
  }

  componentDidUpdate() {
    if (this.state.isEditMode) {
      $('.no-drag').parents('.draggable').removeClass('draggable');
    }
  };

  goToNextItem() {
    const idx = +this.state.activeIdx + 1;
    if (idx >= this.props.items.length) {
      return;
    }
    this.setState({activeIdx: idx, active: this.props.items[idx]});
  }

  goToPrevItem() {
    const idx = +this.state.activeIdx - 1;
    if (idx < 0) {
      return;
    }
    this.setState({activeIdx: idx, active: this.props.items[idx]});
  }

  saveThenGoToItems() {
    markAsModified();
    MenuObject.updateContent(this.props.$element, store.getState().menuObjectItems);
    this.setState({isEditMode: false});
    store.dispatch(actions.goToSubview("items"));
    this.props.updateList();
    this.props.goToItems();
  }

  addExampleToMenu(layout, items) {
    this.props.addExampleItemsToMenu(layout, items);
  }

  componentDidMount() {
    if (this.state.isEditMode) {
      $('.no-drag').parents('.draggable').removeClass('draggable');
    }
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (JSON.stringify(this.props.items) !== JSON.stringify(nextProps.items)) {
      this.forceUpdate();
    }
  }

  render(props, state) {
    if (store.getState().subview === 'add-new') {
      const activeIdx = props.items.length > 0 ? props.items.length - 1 : 0;

      state.isEditMode = true;
      state.activeIdx = activeIdx;
      state.active = props.items[activeIdx];
    }

    if (!store.getState().isMobileVersion) {
      if (JSON.stringify(this.props.items[this.state.activeIdx]) !== JSON.stringify(this.state.active)) {
        state = {
          activeIdx: this.props.activeIdx,
          active: this.props.items[this.props.activeIdx],
          isEditMode: true,
          items: this.props.items
        };
        this.setState(state);
      }
    }

    if (props.$element === null || Object.keys(props.menuObjectStyles).length === 0 || !MenuObject.isMenuObject(this.props.$element)) {
      return (
        <AsideMenuObjectText newMenuObject={props.newMenuObject} addExampleToMenu={this.addExampleToMenu.bind(this)} isPlainText={props.isPlainText} />
      );
    } else {
      return null;
    }
  }
}
